export default {
  searchBar: {
    placeholder: 'Brand, model, year ...',
  },
};
